import React, { useState, useEffect } from 'react';
import '../styles/loading.css';

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isGlitching, setIsGlitching] = useState(true);

  const finalText = 'ANDR31';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*';

  // Efecto de desencriptado
  useEffect(() => {
    let iteration = 0;
    const interval = setInterval(() => {
      setCurrentText(
        finalText
          .split('')
          .map((letter, index) => {
            if (index < iteration) {
              return finalText[index];
            }
            return characters[Math.floor(Math.random() * characters.length)];
          })
          .join('')
      );

      if (iteration >= finalText.length) {
        clearInterval(interval);
        setTimeout(() => {
          setIsGlitching(false);
        }, 500);
      }

      iteration += 1 / 3;
    }, 50);

    return () => clearInterval(interval);
  }, []);

  // Progress bar
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          // Completar inmediatamente cuando llega a 100%
          setTimeout(() => {
            onComplete();
          }, 500);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    return () => clearInterval(interval);
  }, [onComplete]);

  return (
    <div className={`loading-screen ${!isGlitching ? 'fade-out' : ''}`}>
      <div className="glitch-container">
        {/* Multiple layers for glitch effect */}
        <div className="glitch-layer glitch-1">{currentText}</div>
        <div className="glitch-layer glitch-2">{currentText}</div>
        <div className="glitch-layer glitch-3">{currentText}</div>
        <div className="glitch-main">{currentText}</div>
      </div>

      <div className="loading-info">
        <div className="loading-text">
          <span className="typing-text">INITIALIZING TERMINAL SYSTEM...</span>
        </div>

        <div className="progress-container">
          <div className="progress-bar" id="main-progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }}></div>
          </div>
          <div className="progress-text">{progress.toFixed(0)}%</div>
        </div>

        <div className="loading-messages">
          {progress > 10 && <div className="load-msg">✓ Loading security modules...</div>}
          {progress > 30 && <div className="load-msg">✓ Establishing encrypted connection...</div>}
          {progress > 50 && <div className="load-msg">✓ Initializing CTF challenges...</div>}
          {progress > 70 && <div className="load-msg">✓ Loading Web3 scanner...</div>}
          {progress > 90 && <div className="load-msg success">✓ System ready!</div>}
        </div>
      </div>

      {/* Matrix rain effect in background */}
      <div className="matrix-rain">
        {[...Array(20)].map((_, i) => (
          <div key={i} className="matrix-column" style={{ left: `${i * 5}%`, animationDelay: `${i * 0.1}s` }}>
            {[...Array(20)].map((_, j) => (
              <span key={j} style={{ animationDelay: `${j * 0.1}s` }}>
                {characters[Math.floor(Math.random() * characters.length)]}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingScreen;
